import React, { useState } from 'react';
import api from '../services/api';
import { construiesteHtmlRaport, FORMA_FACTURA, FORMA_PRODUCTIE } from '../utils/raportConsum';

// "aaaa-ll-zz" din componente locale (nu toISOString, care ar muta data cu un fus orar)
function iso(an, luna, zi) {
  return `${an}-${String(luna).padStart(2, '0')}-${String(zi).padStart(2, '0')}`;
}

function primaZiLuna() {
  const d = new Date();
  return iso(d.getFullYear(), d.getMonth() + 1, 1);
}

function ultimaZiLuna() {
  const d = new Date();
  return iso(d.getFullYear(), d.getMonth() + 1, new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate());
}

// Tabul "Rapoarte perioada" din Produse finite: raportul de consum de materiale pe o
// perioada. La Print se deschide intai o pagina HTML cu raportul (A4 landscape), care
// are propriul buton de Print - nu se tipareste direct.
export default function RapoartePerioada({ setToast }) {
  const [dataInceput, setDataInceput] = useState(primaZiLuna());
  const [dataSfarsit, setDataSfarsit] = useState(ultimaZiLuna());
  const [forma, setForma] = useState(FORMA_FACTURA);
  const [loading, setLoading] = useState(false);

  async function print() {
    if (!dataInceput || !dataSfarsit) {
      setToast({ message: 'Alege ambele date (de la / pana la)', type: 'error' });
      return;
    }
    if (dataInceput > dataSfarsit) {
      setToast({ message: 'Data "de la" nu poate fi dupa data "pana la"', type: 'error' });
      return;
    }
    // Fereastra se deschide acum, direct din click - dupa un await browserul ar
    // considera-o pop-up nesolicitat si ar bloca-o.
    const fereastra = window.open('', '_blank');
    if (!fereastra) {
      setToast({ message: 'Browserul a blocat fereastra noua - permite ferestrele pop-up pentru acest site', type: 'error' });
      return;
    }
    fereastra.document.write('<p style="font-family:Arial,sans-serif;padding:24px">Se genereaza raportul...</p>');

    setLoading(true);
    try {
      const res = await api.get('/api/rapoarte/consum-perioada', { params: { dataInceput, dataSfarsit } });
      fereastra.document.open();
      fereastra.document.write(construiesteHtmlRaport(res.data, forma));
      fereastra.document.close();
    } catch (e) {
      fereastra.close();
      setToast({ message: e.response?.data?.error || 'Eroare la generarea raportului', type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  const stilOptiune = { display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8, fontSize: 14, cursor: 'pointer' };

  return (
    <div className="card" style={{ maxWidth: 680 }}>
      <h3 style={{ marginTop: 0 }}>Raport consum materiale pe perioada</h3>
      <p style={{ fontSize: 13, color: '#888', marginTop: -6 }}>
        Consumurile de material din productie, evaluate la pretul de intrare al facturii din care se consuma
        (in ordinea intrarii). Print deschide mai intai raportul pe o pagina (A4 landscape), cu buton de print.
      </p>

      <div className="field-row">
        <div className="field">
          <label>De la</label>
          <input type="date" value={dataInceput} onChange={e => setDataInceput(e.target.value)} />
        </div>
        <div className="field">
          <label>Pana la</label>
          <input type="date" value={dataSfarsit} onChange={e => setDataSfarsit(e.target.value)} />
        </div>
      </div>

      <div style={{ margin: '4px 0 14px' }}>
        <label style={stilOptiune}>
          <input type="radio" name="forma-raport" checked={forma === FORMA_FACTURA}
            onChange={() => setForma(FORMA_FACTURA)} style={{ marginTop: 3 }} />
          <span>
            <strong>Consum in functie de factura de intrare</strong><br />
            <span style={{ color: '#777', fontSize: 13 }}>cat a intrat (cantitate, pret, valoare), cat s-a consumat, soldul la sfarsitul perioadei</span>
          </span>
        </label>
        <label style={stilOptiune}>
          <input type="radio" name="forma-raport" checked={forma === FORMA_PRODUCTIE}
            onChange={() => setForma(FORMA_PRODUCTIE)} style={{ marginTop: 3 }} />
          <span>
            <strong>Consum in functie de productia din luna</strong><br />
            <span style={{ color: '#777', fontSize: 13 }}>pe fiecare produs finit cu consum, cu total general si centralizator pe materiale</span>
          </span>
        </label>
      </div>

      <button type="button" className="btn-print" onClick={print} disabled={loading}>
        {loading ? 'Se genereaza...' : 'Print'}
      </button>
    </div>
  );
}
